module.exports = __webpack_public_path__ + "img/diamond-02.601e458f.svg";